import { render } from "./HeroiconsOutlineDocumentReport.vue?vue&type=template&id=8929bfc2"
const script = {}

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDocumentReport.vue"]])

export default __exports__